/**
 * 組合員の声管理検索用VO
 *
 */
export class MembersVoiceSearchModel {


  /**
   * Ｐコード
   */
  public setPcode: Array<string> = new Array<string>();

  /**
   * 生協コード
   */
  public setCoopCode: string = <string>'';

  /**
   * 受注コード
   */
  public setOrderCode: string = <string>'';

  /**
   * 受付番号
   */
  public setReceiptNum: string = <string>'';

  /**
   * 開始受付番号
   */
  public receiptNumFrom: string = <string>'';

  /**
   * 終了受付番号
   */
  public receiptNumTo: string = <string>'';

  /**
   * 部門コード
   */
  public classCode: string = <string>'';

  /**
   * 商品名
   */
  public subject: string = <string>'';

  /**
   * 問合せ内容
   */
  public inquiryContents: string = <string>'';

  /**
   * 開始会員受付日
   */
  public receiptDateFrom: string = <string>'';

  /**
   * 終了会員受付日
   */
  public receiptDateTo: string = <string>'';

  /**
   * 掲載区分
   */
  public publishType: string = <string>'';

  /**
   * 生協コード
   */
  public coopCode: string = <string>'';

  /**
   * 開始PEACE取込日
   */
  public importDateFrom: string = <string>'';

  /**
   * 終了PEACE取込日
   */
  public importDateTo: string = <string>'';

  /**
   * ソート指定項目
   */
  public sortItem: string = <string>'';

  /**
   * 昇順降順
   */
  public sortOrder: string = <string>'';

  /**
   * 取得対象ページ
   */
  public pageNum: number = <number>1;

  /**
   * 初期取得フラグ
   */
  public initFlg: number = <number>0;

  /**
   * 注文商品区分
   */
  public orderGoodsFlg: string = <string>'';
  /**
   * アイテムコード
   */
  public itemCode: string = <string>'';
  /**
   * 受注受付開始コード
   */
  public receiptSOrderCode: string = <string>'';

  /**
   * 注文コード
   */
  public orderNum6Digits: string = <string>'';

  /**
   * いつでも注文の商品情報
   */
  public nvalInputList: Array<any> = new Array<any>();

  /**
   * 画面ＩＤ
   */
  public formId: string = <string>'';

  /**
   * 注文商品区分（コマ割画面遷移用）
   */
  public orderGoodsFlgKoma: Array<any> = new Array<any>();

}
